import { useStageSerialNumbers } from '../hooks/useStageSerialNumbers';

interface SerialValidationResult {
  whid: string;
  organizationId: string;
  inventoryItemId: string;
  serialNumber: string;
  itemNumber: string;
  description: string;
  assetNumber: string;
  serialStatus: string;
  snRepairEligible: string;
}

export const useStageRemainingSerials = () => {
  const { stageSerialNumbers } = useStageSerialNumbers();

  const stageRemainingItems = async (
    selectedResult: SerialValidationResult,
    allResults: SerialValidationResult[],
    returnHeaderId: string,
    userId: string
  ) => {
    // Filter out the selected item to get remaining items
    const remainingItems = allResults.filter(item => 
      item.inventoryItemId !== selectedResult.inventoryItemId
    );
    
    if (remainingItems.length > 0) {
      try {
        // Create JSON with only required fields
        const stageData = remainingItems.map(item => ({
          returnHeaderId,
          whid: item.whid,
          serialNumber: item.serialNumber,
          itemNumber: item.itemNumber,
          serialStatus: item.serialStatus,
          userId
        }));
        
        const serialJson = JSON.stringify(stageData);
        await stageSerialNumbers(serialJson);
        console.log('Successfully staged remaining serial numbers:', stageData);
        return { success: true, stagedCount: remainingItems.length };
      } catch (error) {
        console.error('Failed to stage serial numbers:', error);
        return { success: false, error: error };
      }
    }
    
    return { success: true, stagedCount: 0 };
  };

  return { stageRemainingItems };
};